import { __assign } from "tslib";
import { CallParticipantStatus } from '../twilio';
import { CallType } from './call-type';
import { ExtendedCallStatus } from './extended-call-status';
import { RandomGenerator } from '../../../test-utils';
var PhoneCallBuilder = /** @class */ (function () {
    function PhoneCallBuilder() {
        var user = RandomGenerator.user();
        this.phoneCall = {
            id: '000-000-000-000',
            lineId: '000-000-000-000',
            queueId: '000-000-000-000',
            type: CallType.OUTBOUND,
            user: user,
            userPhoneNumber: { countryCode: '972', number: '545555555' },
            ticketId: '000-000-000-000',
            status: ExtendedCallStatus.IN_QUEUE,
            participants: [
                __assign(__assign({}, user), { status: CallParticipantStatus.TALKING, statusLastUpdateDate: Date.now() - 1000 }),
                __assign(__assign({}, RandomGenerator.user()), { status: CallParticipantStatus.TALKING, statusLastUpdateDate: Date.now() - 1000 }),
                __assign(__assign({}, RandomGenerator.user()), { status: CallParticipantStatus.TALKING, statusLastUpdateDate: Date.now() - 1000 }),
            ],
            recordingDurationSec: 100,
            recordingAvailable: false,
            creationDate: Date.now() - 1000,
            lastUpdateDate: Date.now() - 1000,
            startDate: Date.now() - 1000,
            endDate: Date.now() - 1000,
            ivrStartDate: Date.now() - 1000,
            ivrEndDate: Date.now() - 1000,
            queueStartDate: Date.now() - 1000,
            queueEndDate: Date.now() - 1000,
            wrapUpStartDate: Date.now() - 1000,
            wrapUpEndDate: Date.now() - 1000,
            transferInfo: {},
            fromTransfer: false,
            recordingDeleted: false,
        };
    }
    PhoneCallBuilder.prototype.withId = function (id) {
        this.phoneCall.id = id;
        return this;
    };
    PhoneCallBuilder.prototype.withLineId = function (id) {
        this.phoneCall.lineId = id;
        return this;
    };
    PhoneCallBuilder.prototype.withQueueId = function (id) {
        this.phoneCall.queueId = id;
        return this;
    };
    PhoneCallBuilder.prototype.withTicketId = function (id) {
        this.phoneCall.ticketId = id;
        return this;
    };
    PhoneCallBuilder.prototype.withStatus = function (status) {
        this.phoneCall.status = status;
        return this;
    };
    PhoneCallBuilder.prototype.withType = function (callType) {
        this.phoneCall.type = callType;
        return this;
    };
    PhoneCallBuilder.prototype.withUserPhoneNumber = function (phoneNumber) {
        this.phoneCall.userPhoneNumber = phoneNumber;
        return this;
    };
    PhoneCallBuilder.prototype.addParticipant = function (user, status, maybeStatusLastUpdateDate) {
        var statusLastUpdateDate = maybeStatusLastUpdateDate || Date.now() - 1000;
        var particiapnt = __assign(__assign({}, user), { status: status, statusLastUpdateDate: statusLastUpdateDate });
        this.phoneCall.participants.push(particiapnt);
        return this;
    };
    PhoneCallBuilder.prototype.withQueueStartDate = function (date) {
        this.phoneCall.queueStartDate = date;
        return this;
    };
    PhoneCallBuilder.prototype.withQueueEndDate = function (date) {
        this.phoneCall.queueEndDate = date;
        return this;
    };
    PhoneCallBuilder.prototype.withWrapUpStartDate = function (date) {
        this.phoneCall.wrapUpStartDate = date;
        return this;
    };
    PhoneCallBuilder.prototype.withWrapUpEndDate = function (date) {
        this.phoneCall.wrapUpEndDate = date;
        return this;
    };
    PhoneCallBuilder.prototype.withRecordingDurationSec = function (duration) {
        this.phoneCall.recordingDurationSec = duration;
        return this;
    };
    PhoneCallBuilder.prototype.withRecordingAvailable = function (isRecAvailable) {
        this.phoneCall.recordingAvailable = isRecAvailable;
        return this;
    };
    PhoneCallBuilder.prototype.withCallTransferInfo = function (callTransferInfo) {
        if (callTransferInfo.transferredFromCallId) {
            this.phoneCall.fromTransfer = true;
        }
        this.phoneCall.transferInfo = callTransferInfo;
        return this;
    };
    PhoneCallBuilder.prototype.withPriority = function (priority) {
        this.phoneCall.priority = priority;
        return this;
    };
    PhoneCallBuilder.prototype.withPriorityScore = function (priorityScore) {
        this.phoneCall.priorityScore = priorityScore;
        return this;
    };
    PhoneCallBuilder.prototype.withIvrJourney = function (ivrJourney) {
        this.phoneCall.ivrJourney = ivrJourney;
        return this;
    };
    PhoneCallBuilder.prototype.build = function () {
        return this.phoneCall;
    };
    return PhoneCallBuilder;
}());
export { PhoneCallBuilder };
//# sourceMappingURL=phone-call.builder.js.map